export const ENTRY_VERSION_STATES = {
    LIVE: 'live',
    CURRENT: 'current',
}
